import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-user-confirm-dialog',
  templateUrl: './delete-user-confirm-dialog.component.html',
  styleUrls: ['./delete-user-confirm-dialog.component.scss']
})
export class DeleteUserConfirmDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteUserConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
  }
  deleteUser(): void {
    this.dialogRef.close(true);
  }
  closeDialog() {
    this.dialogRef.close(false);
  }

}
